export default "__VITE_ASSET__1fdNbo0w__"